(() => {
  const normalize = value => String(value).trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  const table = family => sizes.map((size, i) => ({size, width:52 + i * 3, length:Number(((family === 'mercerized' ? 76.9 : 75.4) + i * 2).toFixed(1)), estimated:i > 4}));
  const recommend = ({height, weight, usual, belly = 50, family, offered}) => {
    if (!Number.isFinite(height) || !Number.isFinite(weight) || height < 150 || height > 205 || weight < 45 || weight > 150) return {error:'invalid'};
    const knots = [[45,0],[55,.35],[67.5,1],[80,2],[90,3],[100,4],[110,4.45],[114,5],[125,5.4],[140,6],[150,6.7]];
    let score=0;
    for(let i=1;i<knots.length;i++) {
      if(weight<=knots[i][0]) {const [w0,s0]=knots[i-1], [w1,s1]=knots[i];score=s0+(weight-w0)/(w1-w0)*(s1-s0);break;}
    }
    score += Math.max(0,height-190)*.17;
    score += (Math.max(0,Math.min(100,belly))-50)/100*.7;
    if(family==='mercerized')score += .65*Math.max(0,Math.min(1,(95-weight)/20));
    const usualIndex=sizes.indexOf(normalize(usual));
    const lower=Math.floor(score), fraction=score-lower;
    if(usualIndex>=0 && fraction>=.38 && fraction<=.62 && (usualIndex===lower || usualIndex===lower+1)) {
      score += usualIndex===lower ? -.13 : .13;
    }
    if(score>6.5)return {outside:true};
    const row=table(family)[Math.max(0,Math.round(score))];
    if(!row || !offered.map(normalize).includes(row.size))return {outside:true};
    return {...row,long:row.length/height>.45};
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalize, table, recommend};
  if (typeof customElements === 'undefined' || customElements.get('guttos-fit')) return;
  customElements.define('guttos-fit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-fit-data]').textContent);
      this.t = this.config.text;
      this.dialog = this.querySelector('dialog');
      this.step = 1;
      this.querySelector('[data-open]').hidden = false;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-open]')) this.open();
        if (event.target.closest('[data-close]')) this.dialog.close();
        if (event.target.closest('[data-next]')) this.next();
        if (event.target.closest('[data-back]')) this.go(this.step === 3 ? 2 : 1);
      });
      this.dialog.addEventListener('click', event => {if (event.target === this.dialog) {const b=this.dialog.getBoundingClientRect(); if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();}});
      this.dialog.addEventListener('close', () => {this.unlock();this.querySelector('[data-open]').focus();});
      this.querySelectorAll('[data-range]').forEach(range => {
        range.addEventListener('input', () => {this.querySelector(`[data-number="${range.dataset.range}"]`).value = range.value;this.paint(range);});
        this.paint(range);
      });
      this.querySelectorAll('[data-number]').forEach(number => number.addEventListener('input', () => {
        const range = this.querySelector(`[data-range="${number.dataset.number}"]`);
        if (number.value !== '' && number.validity.valid) {range.value = number.value; this.paint(range);}
      }));
      this.querySelector('[data-belly]').addEventListener('input', () => this.animateBody());
      this.animateBody();
      this.go(1, false);
    }
    disconnectedCallback() {if(this.dialog?.open)this.unlock();}
    paint(range) {range.style.setProperty('--fill', `${(Number(range.value)-Number(range.min))/(Number(range.max)-Number(range.min))*100}%`);range.setAttribute('aria-valuetext', `${range.value} ${range.dataset.range === 'height' ? this.t.cm : this.t.kg}`);this.animateBody();}
    animateBody() {
      const height=Number(this.querySelector('[data-range="height"]').value);
      const weight=Number(this.querySelector('[data-range="weight"]').value);
      const belly=this.querySelector('[data-belly]');
      const b=Number(belly.value)/100;
      const mass=Math.max(0,Math.min(1,(weight-45)/105));
      const shoulder=25+mass*12, waist=20+mass*10+b*15;
      this.querySelector('[data-avatar-body]').setAttribute('transform',`translate(90 258) scale(${.85+mass*.22} ${.75+(height-150)/55*.25}) translate(-90 -258)`);
      this.querySelector('[data-avatar-torso]').setAttribute('d',`M81 60 Q${90-shoulder} 61 ${90-shoulder} 78 Q${90-shoulder+2} 98 ${90-waist} 128 Q${88-waist} 148 65 164 Q90 174 115 164 Q${92+waist} 148 ${90+waist} 128 Q${88+shoulder} 98 ${90+shoulder} 78 Q${90+shoulder} 61 99 60Z`);
      this.querySelector('[data-avatar-arms]').setAttribute('d',`M${90-shoulder} 69 Q${79-shoulder} 71 ${77-shoulder} 94 L${70-shoulder} 150 Q${71-shoulder} 158 ${79-shoulder} 153 L${88-shoulder} 108 L${95-shoulder} 82 M${90+shoulder} 69 Q${101+shoulder} 71 ${103+shoulder} 94 L${110+shoulder} 150 Q${109+shoulder} 158 ${101+shoulder} 153 L${92+shoulder} 108 L${85+shoulder} 82`);
      const label=this.t[b<.34?'belly_flat':b>.66?'belly_full':'belly_mid'];
      this.querySelector('[data-belly-label]').textContent=label;
      belly.setAttribute('aria-valuetext',label);belly.style.setProperty('--fill',`${b*100}%`);
    }
    open() {this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();this.go(this.step);if(this.step===3)this.renderResult(recommend(this.inputs()),this.inputs());}
    unlock() {document.documentElement.style.overflow=this.previousOverflow || '';}
    go(step, focus=true) {
      this.step=step;
      this.querySelectorAll('[data-step]').forEach(el => el.hidden=Number(el.dataset.step)!==step);
      this.querySelector('[data-step-label]').textContent=this.t[`step${step}`];
      this.querySelectorAll('.gf-progress i').forEach((el,i)=>el.classList.toggle('is-done',i<step));
      this.querySelector('[data-back]').hidden=step===1;
      this.querySelector('[data-back]').textContent=step===3?this.t.edit:this.t.back;
      const next=this.querySelector('[data-next]');next.disabled=false;next.textContent=step===1?this.t.next:step===2?this.t.result:this.t.choose;
      this.querySelector('[data-error]').textContent='';
      this.querySelector('.gf-body').scrollTop=0;
      if(focus)this.querySelector('h2').focus({preventScroll:true});
    }
    inputs() {return {height:Number(this.querySelector('[data-number="height"]').value),weight:Number(this.querySelector('[data-number="weight"]').value),belly:Number(this.querySelector('[data-belly]').value),usual:this.querySelector('input[name^="usual-"]:checked')?.value,family:this.config.family,offered:this.config.variants.map(v=>v.options[this.sizeIndex()])};}
    sizeIndex() {return this.config.options.findIndex(name => /^(size|מידה|מידות)$/i.test(name));}
    next() {
      if(this.step===3){this.select();return;}
      const input=this.inputs();const result=recommend(input);
      if(result.error){this.querySelector('[data-error]').textContent=this.t[result.error];return;}
      if(this.step===1){this.go(2);return;}
      this.go(3);this.renderResult(result,input);
    }
    renderResult(result,input) {
      this.answer=result;
      this.querySelector('[data-size]').textContent=result.outside?'—':result.size;
      this.querySelector('[data-result-label]').textContent=result.outside?this.t.outside:this.t.recommend;
      this.querySelector('[data-reason]').textContent=result.outside?this.t.outside_hint:result.direct?this.t.garment_result:this.t.regular_result;
      this.querySelector('[data-length-note]').hidden=!result.long;
      const variant=this.config.variants.find(v=>normalize(v.options[this.sizeIndex()])===result.size);
      this.chosenVariant=variant;
      this.querySelector('[data-stock]').textContent=variant&&!variant.available?this.t.unavailable:'';
      const next=this.querySelector('[data-next]');next.disabled=!variant||!variant.available;next.textContent=variant&&!variant.available?this.t.unavailable:this.t.choose+(result.size?' '+result.size:'');
      const tbody=this.querySelector('[data-chart]');tbody.replaceChildren();
      table(this.config.family).filter(row=>input.offered.map(normalize).includes(row.size)).forEach(row=>{const tr=document.createElement('tr');tr.classList.toggle('is-selected',row.size===result.size);[row.size+(row.estimated?'*':''),row.width,row.length].forEach(value=>{const td=document.createElement('td');td.textContent=value;tr.append(td);});tbody.append(tr);});
    }
    select() {
      if(!this.chosenVariant?.available)return;
      const scope=document.getElementById(`MainProduct-${this.dataset.section}`)||this.closest('product-info');
      const picker=scope?.querySelector('variant-selects');
      const raw=this.chosenVariant.options[this.sizeIndex()];
      const fieldset=picker?.querySelectorAll('fieldset')[this.sizeIndex()];
      const radio=fieldset&&Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(el=>el.value===raw);
      if(radio&&!radio.disabled){this.dialog.close();radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));this.querySelector('[data-status]').textContent=this.t.picked;return;}
      const select=picker?.querySelectorAll('select')[this.sizeIndex()];
      if(select){this.dialog.close();select.value=raw;select.dispatchEvent(new Event('change',{bubbles:true}));this.querySelector('[data-status]').textContent=this.t.picked;return;}
      this.querySelector('[data-error]').textContent=this.t.select_error;
    }
  });
})();
